export default __webpack_public_path__ + "static/media/logo-menu.9e2724c9.svg";